/**
 * Безопасная обёртка над localStorage: в приватном режиме и при запрете хранилища
 * доступ бросает исключение, а приложение должно работать и без него.
 */
export function readStorage(key: string): string | null {
  try {
    return window.localStorage.getItem(key)
  } catch {
    return null
  }
}

export function writeStorage(key: string, value: string): void {
  try {
    window.localStorage.setItem(key, value)
  } catch {
    // Значение просто не запомнится.
  }
}
